// test457
(457 && 0);
